import API from "../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const insertClientReferral = async (params) => {
  try {
    const { data } = await API.post("referral/createReferral", params);
    if (data?.status === 1 || String(data?.message || "").toLowerCase() === "success") {
      return { success: true, message: data?.message || "Success" };
    }
    return {
      success: false,
      message: data?.message || "Failed to submit referral",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "Failed to submit referral",
    };
  }
};

const getAllReferral = createAsyncThunk(
  "referral/getAllReferralStatus",
  async () => {
    try {
      const type = localStorage.getItem("user_role");
      const user_id = localStorage.getItem("user_id");
      const {
        data: { data },
      } = await API.get(
        `referral/getAllReferral${
          type === "client"
            ? "?client_id=" + user_id
            : type === "employee"
            ? "?employee_id=" + user_id
            : "?admin_id=" + user_id
        }`
      );
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
);

export { insertClientReferral, getAllReferral };
